import { Button, Icons } from '@cast/design-system';

export const SeeMoreButton = ({ onClick }: { onClick?: () => void }) => (
  <Button
    variant="text"
    size="md"
    endIcon={<Icons.ArrowRight size={16} />}
    onClick={onClick}
  >
    See more
  </Button>
);
